import api from "../../services/api";
import {
  GET_BRANDS_FAILURE,
  GET_BRANDS_REQUEST,
  GET_BRANDS_SUCCESS,
} from "./ActionType";

const getBrandsRequest = () => ({
  type: GET_BRANDS_REQUEST,
});

const getBrandsSuccess = (brands) => ({
  type: GET_BRANDS_SUCCESS,
  payload: brands,
});

const getBrandsFailure = (error) => ({
  type: GET_BRANDS_FAILURE,
  payload: error,
});

export const getBrands = () => {
  return async (dispatch) => {
    dispatch(getBrandsRequest());
    try {
      const response = await api.get("/brands");
      dispatch(getBrandsSuccess(response.data));
    } catch (error) {
      dispatch(getBrandsFailure(error.message));
    }
  };
};
